import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 007_customer_contacts — split customer contact child rows out of
// accounting_partner_contacts while preserving ids for historical references.
// ============================================================================
export const migration: ModuleMigrationDef = {
  key: "007_customer_contacts",
  version: "1.0.0",
  ignoreErrors: ["no such table: accounting_partner_contacts"],
  sql: `
CREATE TABLE IF NOT EXISTS \`sales_customer_contacts\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`customer_id\` text NOT NULL,
  \`channel_id\` text NOT NULL,
  \`contact_value\` text NOT NULL,
  \`is_primary\` integer NOT NULL DEFAULT 0,
  \`notes\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);

CREATE INDEX IF NOT EXISTS \`sales_customer_contact_customer_idx\`
  ON \`sales_customer_contacts\` (\`customer_id\`);

CREATE INDEX IF NOT EXISTS \`sales_customer_contact_customer_deleted_idx\`
  ON \`sales_customer_contacts\` (\`customer_id\`, \`deleted_at\`);

INSERT OR IGNORE INTO \`sales_customer_contacts\` (
  \`id\`,
  \`customer_id\`,
  \`channel_id\`,
  \`contact_value\`,
  \`is_primary\`,
  \`notes\`,
  \`created_at\`,
  \`created_by\`,
  \`updated_at\`,
  \`updated_by\`,
  \`deleted_at\`,
  \`deleted_by\`
)
SELECT
  pc.\`id\`,
  pc.\`partner_id\`,
  pc.\`channel_id\`,
  pc.\`contact_value\`,
  pc.\`is_primary\`,
  pc.\`notes\`,
  pc.\`created_at\`,
  pc.\`created_by\`,
  pc.\`updated_at\`,
  pc.\`updated_by\`,
  pc.\`deleted_at\`,
  pc.\`deleted_by\`
FROM \`accounting_partner_contacts\` pc
INNER JOIN \`sales_customers\` c
  ON c.\`id\` = pc.\`partner_id\`
WHERE c.\`is_customer\` = 1;
  `.trim(),
};
